import React, { useCallback } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getTextHoverChat } from 'flow/utils/meeting-utils';
import { selectActiveMeetingChatOpen } from 'flow/selectors/meeting-selectors';
import useMeetingChatState from 'flow/hooks/useMeetingChatState';
import useMeetingChatOpen from 'flow/hooks/useMeetingChatOpen';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

const MenuItemOpenChat = () => {
    const { i18next } = useAppContext();

    const chatIsOpen = useAppSelector(selectActiveMeetingChatOpen);
    const { openChat, opensInMeetingChat } = useMeetingChatOpen();
    const { chatDisabled, numberOfUnreadMessages } = useMeetingChatState();

    const getChatMenuText = () => {
        const chatHoverText = getTextHoverChat(
            !chatDisabled,
            opensInMeetingChat,
            chatIsOpen,
            i18next,
        );
        return numberOfUnreadMessages > 0
            ? `${chatHoverText} (${numberOfUnreadMessages})`
            : chatHoverText;
    };

    const handleOpenChatClick = useCallback(() => {
        if (!chatDisabled) {
            openChat();
        }
    }, [chatDisabled, openChat]);

    return (
        <MenuItem
            className={
                chatDisabled
                    ? 'cursor-not-allowed !bg-gray-800 !text-gray-500'
                    : '!bg-gray-800 !text-white hover:!bg-gray-700'
            }
            onClick={handleOpenChatClick}
            disabled={chatDisabled}
        >
            <Icon iconKey="chat" className="me-1.5" />
            <div>{getChatMenuText()}</div>
        </MenuItem>
    );
};

export default MenuItemOpenChat;
